import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { MagentoObjectDataset } from 'app/model/dataset/magento.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MagentoObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class MagentoObjectDatasetAdapter extends TabularTypeDatasetAdapter<MagentoObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MagentoObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MagentoObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MagentoObjectDataset): Promise<MagentoObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MagentoObjectDataset.MODEL);
    }
}
